// import React, { useState } from "react";
// import {
//   Zap,
//   ChevronRight,
//   Check,
//   X,
//   Star,
//   MessageCircle,
//   Target,
//   Search,
//   Calendar,
//   BarChart3,
//   ArrowRight,
//   Download,
//   Edit,
//   Save,
//   Users,
// } from "lucide-react";

// const HybridBusinessPlanner = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [idea, setIdea] = useState("");
//   const [isGenerating, setIsGenerating] = useState(false);
//   const [selectedSections, setSelectedSections] = useState({});

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (idea.trim()) {
//       setIsGenerating(true);
//       setTimeout(() => {
//         setIsGenerating(false);
//         setCurrentStep(2);

//         // Simulate AI recommending sections
//         const initialSections = {};
//         planSections.forEach((category) => {
//           category.sections.forEach((section) => {
//             initialSections[section.id] = true;
//           });
//         });
//         setSelectedSections(initialSections);
//       }, 2000);
//     }
//   };

//   const toggleSection = (sectionId) => {
//     setSelectedSections({
//       ...selectedSections,
//       [sectionId]: !selectedSections[sectionId],
//     });
//   };

//   const countSelectedSections = () => {
//     return Object.values(selectedSections).filter((v) => v).length;
//   };

//   const generatePlan = () => {
//     setIsGenerating(true);
//     setTimeout(() => {
//       setIsGenerating(false);
//       setCurrentStep(3);
//     }, 2000);
//   };

//   // Define sections groups and their sub-sections
//   const planSections = [
//     {
//       id: "foundation",
//       title: "Business Foundation",
//       sections: [
//         { id: "exec-summary", title: "Executive Summary", recommended: true },
//         { id: "problem-solution", title: "Problem & Solution Statement", recommended: true },
//         {
//           id: "validation",
//           title: "Idea Validation Score",
//           recommended: true,
//           premium: true,
//           icon: <BarChart3 className="h-4 w-4 text-purple-600" />,
//         },
//         { id: "market-size", title: "Market Size & Growth Analysis", recommended: true },
//         { id: "value-prop", title: "Value Proposition & Positioning", recommended: true },
//       ],
//     },
//     {
//       id: "market",
//       title: "Market Intelligence",
//       sections: [
//         {
//           id: "social-reality",
//           title: "Social Media Reality Check",
//           recommended: true,
//           premium: true,
//           icon: <MessageCircle className="h-4 w-4 text-purple-600" />,
//         },
//         {
//           id: "competitive",
//           title: "Competitive Weakness Detector",
//           recommended: true,
//           premium: true,
//           icon: <Search className="h-4 w-4 text-purple-600" />,
//         },
//         { id: "customer-persona", title: "Target Customer Persona", recommended: true },
//         {
//           id: "first-customer",
//           title: "First Customer Finder",
//           recommended: true,
//           premium: true,
//           icon: <Target className="h-4 w-4 text-purple-600" />,
//         },
//         { id: "tam", title: "Total Addressable Market & Expansion Strategy", recommended: true },
//       ],
//     },
//     {
//       id: "product",
//       title: "Product Strategy",
//       sections: [
//         { id: "core-features", title: "Core Features Definition", recommended: true },
//         { id: "tech-stack", title: "Technology Requirements & Stack", recommended: true },
//         { id: "mvp-timeline", title: "MVP Development Timeline", recommended: true },
//         { id: "pricing", title: "Pricing Strategy & Revenue Model", recommended: true },
//         { id: "why-now", title: "Why Now? Market Timing Analysis", recommended: true },
//       ],
//     },
//     {
//       id: "execution",
//       title: "Execution Roadmap",
//       sections: [
//         {
//           id: "revenue-roadmap",
//           title: "60-Day Revenue Roadmap",
//           recommended: true,
//           premium: true,
//           icon: <Calendar className="h-4 w-4 text-purple-600" />,
//         },
//         { id: "acquisition", title: "Customer Acquisition Strategy", recommended: true },
//         { id: "marketing", title: "Marketing & Growth Tactics", recommended: true },
//         { id: "metrics", title: "Key Success Metrics & KPIs", recommended: true },
//         { id: "resources", title: "Resource Requirements", recommended: true },
//       ],
//     },
//     {
//       id: "investment",
//       title: "Investment Case",
//       sections: [
//         {
//           id: "funding-score",
//           title: "Funding Probability Score",
//           recommended: true,
//           premium: true,
//           icon: <BarChart3 className="h-4 w-4 text-purple-600" />,
//         },
//         { id: "capital", title: "Capital Requirements & Allocation", recommended: true },
//         { id: "financials", title: "Financial Projections", recommended: true },
//         { id: "risk", title: "Risk Assessment & Mitigation", recommended: true },
//         { id: "pitch", title: "Investor Pitch Framework", recommended: true },
//       ],
//     },
//   ];

//   // Define premium features content for Step 3
//   const premiumFeatures = [
//     {
//       title: "Social Media Reality Check",
//       icon: <MessageCircle className="w-5 h-5 text-white" />,
//       color: "bg-indigo-600",
//       content: "Based on analysis of 1,293 social media posts about products similar to yours in the past 30 days",
//     },
//     {
//       title: "First Customer Finder",
//       icon: <Target className="w-5 h-5 text-white" />,
//       color: "bg-emerald-600",
//       content: "5 high-probability first customers identified based on behavioral and firmographic data",
//     },
//     {
//       title: "Competitive Weakness Detector",
//       icon: <Search className="w-5 h-5 text-white" />,
//       color: "bg-amber-600",
//       content: "3 major competitors analyzed with 7 exploitable weaknesses identified",
//     },
//     {
//       title: "60-Day Revenue Roadmap",
//       icon: <Calendar className="w-5 h-5 text-white" />,
//       color: "bg-rose-600",
//       content: "Step-by-step plan to generate first revenue in 37 days based on your business model",
//     },
//     {
//       title: "Funding Probability Score",
//       icon: <BarChart3 className="w-5 h-5 text-white" />,
//       color: "bg-blue-600",
//       content: "73% probability of securing funding based on analysis of 10,000+ similar startups",
//     },
//   ];

//   // Render the appropriate step
//   const renderStep = () => {
//     switch (currentStep) {
//       case 1:
//         return (
//           <div className="max-w-3xl mx-auto">
//             <div className="text-center mb-8">
//               <h2 className="text-3xl font-bold text-gray-900">Create Your Business Plan</h2>
//               <p className="mt-2 text-lg text-gray-600">Personalized to your needs with data-driven insights</p>
//             </div>

//             <form onSubmit={handleSubmit} className="space-y-6">
//               <div className="bg-white border-2 border-gray-200 rounded-xl shadow-sm overflow-hidden hover:border-purple-400 transition-colors focus-within:border-purple-400 focus-within:ring-1 focus-within:ring-purple-400">
//                 <textarea
//                   rows={6}
//                   className="block w-full border-0 py-4 px-6 focus:ring-0 text-lg placeholder-gray-400"
//                   placeholder="Describe your business idea in detail..."
//                   value={idea}
//                   onChange={(e) => setIdea(e.target.value)}
//                 />
//                 <div className="py-3 px-6 bg-gray-50 flex items-center justify-between">
//                   <p className="text-sm text-gray-500">AI will recommend the most relevant sections for your business</p>
//                   <button
//                     type="submit"
//                     disabled={isGenerating || !idea.trim()}
//                     className={`flex items-center px-6 py-3 rounded-lg font-medium text-base text-white transition-colors ${
//                       isGenerating || !idea.trim() ? "bg-gray-400 cursor-not-allowed" : "bg-purple-600 hover:bg-purple-700"
//                     }`}
//                   >
//                     {isGenerating ? (
//                       <>
//                         <span className="mr-2">Analyzing</span>
//                         <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
//                       </>
//                     ) : (
//                       <>
//                         <span>Analyze Idea</span>
//                         <ArrowRight className="ml-2 h-5 w-5" />
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </form>
//           </div>
//         );

//       case 2:
//         return (
//           <div className="max-w-4xl mx-auto">
//             <div className="text-center mb-8">
//               <h2 className="text-3xl font-bold text-gray-900">Customize Your Business Plan</h2>
//               <p className="mt-2 text-lg text-gray-600">We've analyzed your idea and recommended the most relevant sections</p>
//             </div>

//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-8">
//               <div className="p-6">
//                 <div className="flex items-start mb-6">
//                   <div className="mr-4 p-3 rounded-full bg-purple-100">
//                     <Zap className="h-6 w-6 text-purple-600" />
//                   </div>
//                   <div>
//                     <h3 className="text-lg font-medium text-gray-900">AI Analysis Complete</h3>
//                     <p className="mt-1 text-gray-600">
//                       Based on your idea for "{idea.length > 40 ? idea.substring(0, 40) + "..." : idea}", we've selected{" "}
//                       {countSelectedSections()} sections for your business plan.
//                     </p>
//                   </div>
//                 </div>

//                 <div className="border-t border-gray-200 pt-4">
//                   <div className="flex justify-between items-center mb-4">
//                     <h4 className="font-medium text-gray-900">Customize Your Plan Sections</h4>
//                     <div className="text-sm text-gray-500">{countSelectedSections()} sections selected</div>
//                   </div>

//                   <div className="space-y-6">
//                     {planSections.map((category) => (
//                       <div key={category.id} className="border border-gray-200 rounded-lg overflow-hidden">
//                         <div className="bg-gray-50 px-4 py-3 font-medium text-gray-900">{category.title}</div>
//                         <div className="divide-y divide-gray-200">
//                           {category.sections.map((section) => (
//                             <div key={section.id} className="px-4 py-3 flex items-center justify-between">
//                               <div className="flex items-center">
//                                 <button
//                                   onClick={() => toggleSection(section.id)}
//                                   className={`w-5 h-5 mr-3 rounded flex items-center justify-center ${
//                                     selectedSections[section.id] ? "bg-purple-600" : "border border-gray-300"
//                                   }`}
//                                 >
//                                   {selectedSections[section.id] && <Check className="h-3 w-3 text-white" />}
//                                 </button>
//                                 <span className="text-gray-700">{section.title}</span>
//                                 {section.premium && (
//                                   <div className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800">
//                                     <Star className="h-3 w-3 mr-1" />
//                                     Premium
//                                   </div>
//                                 )}
//                               </div>
//                               {section.recommended && <span className="text-xs text-gray-500">Recommended</span>}
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//               <div className="px-6 py-4 bg-gray-50 flex justify-between items-center">
//                 <button onClick={() => setCurrentStep(1)} className="text-gray-600 hover:text-gray-900">
//                   Back to Idea
//                 </button>
//                 <button
//                   onClick={generatePlan}
//                   disabled={isGenerating || countSelectedSections() === 0}
//                   className={`flex items-center px-6 py-3 rounded-lg font-medium text-base text-white transition-colors ${
//                     isGenerating || countSelectedSections() === 0 ? "bg-gray-400 cursor-not-allowed" : "bg-purple-600 hover:bg-purple-700"
//                   }`}
//                 >
//                   {isGenerating ? (
//                     <>
//                       <span className="mr-2">Generating</span>
//                       <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
//                     </>
//                   ) : (
//                     <>
//                       <span>Generate Business Plan</span>
//                       <ChevronRight className="ml-2 h-5 w-5" />
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>
//           </div>
//         );

//       case 3:
//         return (
//           <div className="max-w-6xl mx-auto">
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-8">
//               <div className="flex border-b border-gray-200">
//                 <div className="px-6 py-4 border-r border-gray-200 w-64">
//                   <h3 className="font-bold text-gray-900 mb-4">Your Business Plan</h3>
//                   <div className="space-y-1">
//                     {planSections.map((category) => (
//                       <div key={category.id} className="mb-4">
//                         <div className="font-medium text-gray-700 mb-2">{category.title}</div>
//                         <div className="ml-2 space-y-1">
//                           {category.sections.map(
//                             (section) =>
//                               selectedSections[section.id] && (
//                                 <div key={section.id} className="flex items-center text-sm py-1 px-2 rounded hover:bg-gray-100">
//                                   <span className="text-gray-600">{section.title}</span>
//                                   {section.premium && <Star className="h-3 w-3 ml-1 text-purple-600" />}
//                                 </div>
//                               )
//                           )}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                   <div className="mt-6">
//                     <button className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
//                       <Download className="mr-2 h-4 w-4" />
//                       Export as PDF
//                     </button>
//                   </div>
//                 </div>

//                 <div className="flex-1 flex flex-col">
//                   <div className="p-6 border-b border-gray-200">
//                     <div className="flex justify-between items-start">
//                       <div>
//                         <h2 className="text-2xl font-bold text-gray-900 flex items-center">
//                           {idea.length > 40 ? idea.substring(0, 40) + "..." : idea}
//                           <button className="ml-2 text-gray-400 hover:text-gray-600">
//                             <Edit className="h-4 w-4" />
//                           </button>
//                         </h2>
//                         <p className="text-gray-500 mt-1">Generated on {new Date().toLocaleDateString()}</p>
//                       </div>
//                       <div className="flex space-x-2">
//                         <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
//                           Share
//                         </button>
//                         <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
//                           Save
//                         </button>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="p-6 overflow-auto flex-1">
//                     <div className="mb-8">
//                       <h3 className="text-xl font-bold text-gray-900 mb-4">Executive Summary</h3>
//                       <p className="text-gray-700 mb-3">
//                         Your business addresses a significant gap in the market for [product/service]. With a total addressable market of
//                         $4.7B growing at 17% annually, there is substantial opportunity for capturing market share.
//                       </p>
//                       <p className="text-gray-700">
//                         Initial analysis indicates a 73% funding probability and potential to generate first revenue within 37 days of
//                         launch by focusing on your core competitive advantages and targeting the identified high-probability customers.
//                       </p>
//                     </div>

//                     <div className="mb-8">
//                       <div className="flex items-center mb-4">
//                         <h3 className="text-xl font-bold text-gray-900">Premium Insights</h3>
//                         <div className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800">
//                           <Star className="h-3 w-3 mr-1" />
//                           Pro Feature
//                         </div>
//                       </div>

//                       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                         {premiumFeatures.map((feature, index) => (
//                           <div
//                             key={index}
//                             className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow"
//                           >
//                             <div className={`${feature.color} py-3 px-4`}>
//                               <div className="flex items-center">
//                                 <div className="p-1 rounded-lg">{feature.icon}</div>
//                                 <h4 className="ml-2 font-bold text-white text-base">{feature.title}</h4>
//                               </div>
//                             </div>
//                             <div className="p-4">
//                               <p className="text-sm text-gray-600">{feature.content}</p>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>

//                     <div className="border-t border-gray-200 pt-6">
//                       <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//                         <div>
//                           <h3 className="text-lg font-bold text-gray-900 mb-3">Social Media Reality Check</h3>
//                           <div className="bg-gray-50 rounded-lg p-4">
//                             <div className="mb-4">
//                               <div className="flex justify-between mb-1">
//                                 <span className="text-sm font-medium text-gray-700">Positive</span>
//                                 <span className="text-sm font-medium text-gray-700">67%</span>
//                               </div>
//                               <div className="w-full bg-gray-200 rounded-full h-2">
//                                 <div className="bg-green-500 h-2 rounded-full" style={{ width: "67%" }}></div>
//                               </div>
//                             </div>
//                             <div className="mb-4">
//                               <div className="flex justify-between mb-1">
//                                 <span className="text-sm font-medium text-gray-700">Neutral</span>
//                                 <span className="text-sm font-medium text-gray-700">24%</span>
//                               </div>
//                               <div className="w-full bg-gray-200 rounded-full h-2">
//                                 <div className="bg-gray-400 h-2 rounded-full" style={{ width: "24%" }}></div>
//                               </div>
//                             </div>
//                             <div>
//                               <div className="flex justify-between mb-1">
//                                 <span className="text-sm font-medium text-gray-700">Negative</span>
//                                 <span className="text-sm font-medium text-gray-700">9%</span>
//                               </div>
//                               <div className="w-full bg-gray-200 rounded-full h-2">
//                                 <div className="bg-red-500 h-2 rounded-full" style={{ width: "9%" }}></div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>

//                         <div>
//                           <h3 className="text-lg font-bold text-gray-900 mb-3">First Customer Finder</h3>
//                           <div className="bg-gray-50 rounded-lg p-4">
//                             <div className="flex items-center mb-3">
//                               <div className="flex-shrink-0 h-10 w-10 rounded-full bg-purple-100 flex items-center justify-center">
//                                 <Users className="h-5 w-5 text-purple-600" />
//                               </div>
//                               <div className="ml-3">
//                                 <div className="text-sm font-medium text-gray-900">TechStart Solutions</div>
//                                 <div className="text-xs text-gray-500">97% match probability</div>
//                               </div>
//                             </div>
//                             <div className="flex items-center">
//                               <div className="flex-shrink-0 h-10 w-10 rounded-full bg-purple-100 flex items-center justify-center">
//                                 <Users className="h-5 w-5 text-purple-600" />
//                               </div>
//                               <div className="ml-3">
//                                 <div className="text-sm font-medium text-gray-900">GrowFast Marketing</div>
//                                 <div className="text-xs text-gray-500">89% match probability</div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <header className="bg-white shadow-sm">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center py-6">
//             <div className="flex items-center">
//               <Zap className="h-8 w-8 text-purple-600" />
//               <h1 className="ml-2 text-2xl font-bold text-gray-900">LaunchPad AI</h1>
//             </div>

//             <nav className="flex space-x-8">
//               <a href="#" className="text-gray-900 hover:text-gray-900 px-3 py-2 font-medium text-sm">
//                 Home
//               </a>
//               <a href="#" className="text-gray-500 hover:text-gray-900 px-3 py-2 font-medium text-sm">
//                 Features
//               </a>
//               <a href="#" className="text-gray-500 hover:text-gray-900 px-3 py-2 font-medium text-sm">
//                 Pricing
//               </a>
//             </nav>

//             <div>
//               <button className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-purple-600 hover:bg-purple-700">
//                 Sign Up
//               </button>
//             </div>
//           </div>
//         </div>
//       </header>

//       <main className="py-8">
//         <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
//           {/* Steps indicator */}
//           <div className="max-w-3xl mx-auto mb-8">
//             <div className="flex items-center justify-center">
//               <div className={`flex items-center ${currentStep > 1 ? "text-purple-600" : "text-gray-600"}`}>
//                 <div
//                   className={`flex items-center justify-center w-8 h-8 rounded-full ${
//                     currentStep >= 1 ? "bg-purple-600 text-white" : "bg-gray-200 text-gray-600"
//                   }`}
//                 >
//                   1
//                 </div>
//                 <span className="ml-2 text-sm font-medium hidden sm:block">Enter Idea</span>
//               </div>
//               <div className={`w-12 sm:w-24 h-1 mx-2 ${currentStep > 1 ? "bg-purple-600" : "bg-gray-200"}`}></div>
//               <div className={`flex items-center ${currentStep > 2 ? "text-purple-600" : "text-gray-600"}`}>
//                 <div
//                   className={`flex items-center justify-center w-8 h-8 rounded-full ${
//                     currentStep >= 2 ? "bg-purple-600 text-white" : "bg-gray-200 text-gray-600"
//                   }`}
//                 >
//                   2
//                 </div>
//                 <span className="ml-2 text-sm font-medium hidden sm:block">Select Sections</span>
//               </div>
//               <div className={`w-12 sm:w-24 h-1 mx-2 ${currentStep > 2 ? "bg-purple-600" : "bg-gray-200"}`}></div>
//               <div className={`flex items-center ${currentStep > 3 ? "text-purple-600" : "text-gray-600"}`}>
//                 <div
//                   className={`flex items-center justify-center w-8 h-8 rounded-full ${
//                     currentStep >= 3 ? "bg-purple-600 text-white" : "bg-gray-200 text-gray-600"
//                   }`}
//                 >
//                   3
//                 </div>
//                 <span className="ml-2 text-sm font-medium hidden sm:block">View Report</span>
//               </div>
//             </div>
//           </div>

//           {renderStep()}
//         </div>
//       </main>
//     </div>
//   );
// };

// export default HybridBusinessPlanner;

// import React, { useState } from "react";
// import {
//   Zap,
//   ChevronRight,
//   ChevronDown,
//   Check,
//   Lock,
//   Star,
//   MessageCircle,
//   Target,
//   Search,
//   Calendar,
//   BarChart3,
//   ArrowRight,
//   Download,
//   CreditCard,
//   Shield,
//   ExternalLink,
//   EyeOff,
//   Eye,
//   Copy,
// } from "lucide-react";

// const BusinessPlannerFinalStrategy = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [businessType, setBusinessType] = useState("");
//   const [businessIdea, setBusinessIdea] = useState("");
//   const [isGenerating, setIsGenerating] = useState(false);
//   const [selectedPlan, setSelectedPlan] = useState("standard");
//   const [activeSection, setActiveSection] = useState("");
//   const [showSections, setShowSections] = useState(true);

//   // Sample business types for the dropdown
//   const businessTypes = [
//     { value: "ecommerce", label: "E-commerce / Online Retail" },
//     { value: "saas", label: "SaaS / Software Company" },
//     { value: "local", label: "Local Service Business" },
//     { value: "food", label: "Restaurant / Food Service" },
//     { value: "health", label: "Healthcare / Wellness" },
//     { value: "manufacturing", label: "Manufacturing" },
//     { value: "consulting", label: "Consulting / Professional Services" },
//     { value: "education", label: "Education / E-learning" },
//   ];

//   // Define plan types
//   const planTypes = {
//     standard: {
//       title: "Standard Plan",
//       price: "$39",
//       description: "Complete 100+ page business plan with industry-specific sections",
//       features: [
//         "All 55 industry-tailored sections",
//         "Executive Summary",
//         "Comprehensive financial projections",
//         "Complete market analysis",
//         "In-depth competitive research",
//       ],
//     },
//     professional: {
//       title: "Professional Plan",
//       price: "$59",
//       description: "Everything in Standard plus 5 premium data-driven insights",
//       features: [
//         "All 55 industry-tailored sections",
//         "Social Media Reality Check",
//         "Competitive Weakness Detector",
//         "First Customer Finder",
//         "60-Day Revenue Roadmap",
//         "Funding Probability Score",
//       ],
//     },
//   };

//   // Generate sample section titles based on business type
//   const generateSectionTitles = (type) => {
//     // These would be dynamically generated by ChatGPT API in the real implementation
//     if (type === "ecommerce") {
//       return {
//         marketResearch: "E-commerce Market Opportunity Analysis",
//         competitiveAnalysis: "Online Retail Competitive Landscape",
//         customerAcquisition: "Digital Customer Acquisition Strategy",
//         inventoryManagement: "E-commerce Inventory & Fulfillment Strategy",
//         pricing: "E-commerce Pricing & Margin Optimization",
//       };
//     } else if (type === "saas") {
//       return {
//         marketResearch: "SaaS Market Penetration Strategy",
//         competitiveAnalysis: "Software Industry Competitive Analysis",
//         customerAcquisition: "B2B SaaS Customer Acquisition Framework",
//         inventoryManagement: "Product Development & Release Cycle",
//         pricing: "SaaS Subscription Model & Pricing Tiers",
//       };
//     } else if (type === "food") {
//       return {
//         marketResearch: "Food Service Local Market Analysis",
//         competitiveAnalysis: "Restaurant Competitive Positioning",
//         customerAcquisition: "Food Service Customer Loyalty Strategy",
//         inventoryManagement: "Food Inventory & Supplier Management",
//         pricing: "Menu Pricing & Food Cost Optimization",
//       };
//     } else {
//       return {
//         marketResearch: "Market Research & Analysis",
//         competitiveAnalysis: "Competitive Analysis",
//         customerAcquisition: "Customer Acquisition Strategy",
//         inventoryManagement: "Operations Management",
//         pricing: "Pricing Strategy",
//       };
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (businessIdea.trim()) {
//       setIsGenerating(true);
//       setTimeout(() => {
//         setIsGenerating(false);
//         setCurrentStep(2);
//       }, 2000);
//     }
//   };

//   const handleGeneratePlan = () => {
//     setIsGenerating(true);
//     setTimeout(() => {
//       setIsGenerating(false);
//       setCurrentStep(3);
//       setActiveSection("executive-summary");
//     }, 3000);
//   };

//   // Sample dynamic section titles based on selected business type
//   const sectionTitles = generateSectionTitles(businessType);

//   // Define sections for the business plan
//   const businessPlanSections = [
//     {
//       title: "Executive Summary",
//       id: "executive-summary",
//       category: "Introduction",
//       type: "standard",
//     },
//     {
//       title: "Business Overview",
//       id: "business-overview",
//       category: "Introduction",
//       type: "standard",
//     },
//     {
//       title: sectionTitles.marketResearch,
//       id: "market-research",
//       category: "Market Opportunity",
//       type: "standard",
//     },
//     {
//       title: "Social Media Reality Check",
//       id: "social-media-check",
//       category: "Market Opportunity",
//       type: "premium",
//       icon: <MessageCircle className="h-4 w-4" />,
//     },
//     {
//       title: "Target Customer Analysis",
//       id: "target-customer",
//       category: "Market Opportunity",
//       type: "standard",
//     },
//     {
//       title: "First Customer Finder",
//       id: "first-customer",
//       category: "Market Opportunity",
//       type: "premium",
//       icon: <Target className="h-4 w-4" />,
//     },
//     {
//       title: sectionTitles.competitiveAnalysis,
//       id: "competitive-analysis",
//       category: "Competitive Landscape",
//       type: "standard",
//     },
//     {
//       title: "Competitive Weakness Detector",
//       id: "competitive-weakness",
//       category: "Competitive Landscape",
//       type: "premium",
//       icon: <Search className="h-4 w-4" />,
//     },
//     {
//       title: "Product Description",
//       id: "product-description",
//       category: "Product Strategy",
//       type: "standard",
//     },
//     {
//       title: sectionTitles.pricing,
//       id: "pricing-strategy",
//       category: "Product Strategy",
//       type: "standard",
//     },
//     {
//       title: sectionTitles.customerAcquisition,
//       id: "customer-acquisition",
//       category: "Go-to-Market Strategy",
//       type: "standard",
//     },
//     {
//       title: "60-Day Revenue Roadmap",
//       id: "revenue-roadmap",
//       category: "Go-to-Market Strategy",
//       type: "premium",
//       icon: <Calendar className="h-4 w-4" />,
//     },
//     {
//       title: "Financial Projections",
//       id: "financial-projections",
//       category: "Financials",
//       type: "standard",
//     },
//     {
//       title: "Funding Requirements",
//       id: "funding-requirements",
//       category: "Funding & Growth",
//       type: "standard",
//     },
//     {
//       title: "Funding Probability Score",
//       id: "funding-probability",
//       category: "Funding & Growth",
//       type: "premium",
//       icon: <BarChart3 className="h-4 w-4" />,
//     },
//     {
//       title: sectionTitles.inventoryManagement,
//       id: "operations",
//       category: "Operations",
//       type: "standard",
//     },
//   ];

//   // Group sections by category
//   const groupedSections = businessPlanSections.reduce((acc, section) => {
//     if (!acc[section.category]) {
//       acc[section.category] = [];
//     }
//     acc[section.category].push(section);
//     return acc;
//   }, {});

//   // Sample Content for Sections
//   const sectionContent = {
//     "executive-summary": `
//       # Executive Summary

//       ## Business Overview

//       ${
//         businessIdea || "This AI-powered business will..."
//       } represents a significant opportunity in the market. The solution addresses key pain points experienced by customers in this space while providing a competitive advantage through its unique approach.

//       ## Target Market

//       The primary target market consists of [target customer profile] who currently struggle with [key problem]. This represents approximately [market size] in [target geography], with an estimated [percentage]% experiencing related challenges.

//       ## Competitive Advantage

//       Unlike existing solutions in the market, this business:

//       1. [Key differentiator 1]
//       2. [Key differentiator 2]
//       3. [Key differentiator 3]
//       4. [Key differentiator 4]

//       ## Financial Projection Highlights

//       * First revenue expected within [X] days of launch
//       * Projected first-year revenue: $[amount]
//       * Estimated break-even point: Month [X]
//       * [X]% probability of securing seed funding based on market dynamics

//       ## Funding Request

//       $[amount] in seed funding is sought to complete development, launch marketing initiatives, and support operations for the first 12 months until the business achieves sustainable revenue growth.
//     `,
//     "social-media-check": `
//       # Social Media Reality Check

//       ## Analysis Overview

//       We analyzed 1,293 social media conversations about ${
//         businessType === "ecommerce" ? "e-commerce solutions" : businessType === "saas" ? "software solutions" : "business solutions"
//       } over the past 90 days across Reddit, Twitter, LinkedIn, and industry forums. This analysis provides real-world insights into what actual users are saying about existing solutions and their unmet needs.

//       ## Sentiment Analysis

//       Overall sentiment distribution for solutions in this space:

//       * Positive: 67% (primarily focused on [positive aspects])
//       * Neutral: 24% (feature requests and general questions)
//       * Negative: 9% (focused on [negative aspects])

//       ## Most Mentioned Pain Points

//       1. **[Pain point 1] (37% of negative mentions)**
//         *"[Actual customer quote from social media]"* - Reddit user

//       2. **[Pain point 2] (32% of negative mentions)**
//         *"[Actual customer quote from social media]"* - Twitter user

//       3. **[Pain point 3] (21% of negative mentions)**
//         *"[Actual customer quote from social media]"* - Industry forum

//       ## Frequently Requested Features

//       1. **[Feature request 1] (mentioned in 49% of feature requests)**
//         *"[Actual customer quote about desired feature]"*

//       2. **[Feature request 2] (mentioned in 33% of feature requests)**
//         *"[Actual customer quote about desired feature]"*

//       3. **[Feature request 3] (mentioned in 28% of feature requests)**
//         *"[Actual customer quote about desired feature]"*

//       ## Strategic Recommendations

//       1. Position marketing to directly address [top pain point]
//       2. Emphasize [key positive aspect] in all demonstrations
//       3. Consider [strategic recommendation based on data]
//       4. Highlight [key differentiator] as the primary selling point
//     `,
//     "competitive-weakness": `
//       # Competitive Weakness Detector

//       ## Competitor Analysis Overview

//       We analyzed 3 major competitors in the ${
//         businessType || "business"
//       } space, examining their product offerings, customer reviews, support forums, and social media mentions to identify exploitable weaknesses and gaps in their solutions.

//       ## Competitor A: [Competitor Name] (Market Leader - 35% share)

//       *Product Positioning:* [Competitor positioning statement]

//       **Identified Weaknesses:**

//       1. **[Weakness 1] (mentioned in 47% of negative reviews)**
//         * [Specific details about weakness]
//         * [Impact on customers]
//         * *Exploitation strategy:* [How to capitalize on this weakness]

//       2. **[Weakness 2] (average issue impact: high)**
//         * [Specific details about weakness]
//         * [Impact on customers]
//         * *Exploitation strategy:* [How to capitalize on this weakness]

//       3. **[Weakness 3] (growing complaint trend)**
//         * [Specific details about weakness]
//         * [Impact on customers]
//         * *Exploitation strategy:* [How to capitalize on this weakness]

//       ## Competitor B: [Competitor Name] (Fast-growing - 18% share)

//       *Product Positioning:* [Competitor positioning statement]

//       **Identified Weaknesses:**

//       1. **[Weakness 1] (67% of users report issues)**
//         * [Specific details about weakness]
//         * [Impact on customers]
//         * *Exploitation strategy:* [How to capitalize on this weakness]

//       2. **[Weakness 2] (significant opportunity)**
//         * [Specific details about weakness]
//         * [Impact on customers]
//         * *Exploitation strategy:* [How to capitalize on this weakness]

//       ## Market Gap Analysis

//       Based on competitor offerings, there is a significant opportunity for a solution that:

//       1. [Market gap 1]
//       2. [Market gap 2]
//       3. [Market gap 3]
//       4. [Market gap 4]

//       ## Recommended Positioning

//       Position as "[Positioning statement based on competitive analysis]" to directly exploit the identified weaknesses across all competitors.
//     `,
//     "first-customer": `
//       # First Customer Finder

//       ## Customer Targeting Overview

//       Using behavioral and firmographic data analysis, we've identified 5 high-probability first customers for your ${
//         businessType || "business"
//       } solution. These prospects are selected based on signals indicating they are actively looking for solutions and have characteristics that align with your ideal customer profile.

//       ## High-Priority Target Companies

//       ### 1. [Target Company Name] (97% match)

//       **Company Profile:**
//       * [Company size/locations]
//       * [Employee count]
//       * [Revenue range]
//       * [Current solution they're using]

//       **Why They're Ready to Buy:**
//       * [Recent trigger event]
//       * [Pain point signal]
//       * [Buying behavior indicator]

//       **Contact Strategy:**
//       * Primary contact: [Name], [Position]
//       * [Platform] activity suggests they're online [time pattern]
//       * Content trigger: [Content piece to share]
//       * Suggested opener: "[Personalized conversation starter]"

//       ### 2. [Target Company Name] (89% match)

//       **Company Profile:**
//       * [Company size/locations]
//       * [Employee count]
//       * [Revenue range]
//       * [Current solution they're using]

//       **Why They're Ready to Buy:**
//       * [Recent trigger event]
//       * [Pain point signal]
//       * [Buying behavior indicator]

//       **Contact Strategy:**
//       * Primary contact: [Name], [Position]
//       * [Platform] activity suggests they're online [time pattern]
//       * Content trigger: [Content piece to share]
//       * Suggested opener: "[Personalized conversation starter]"

//       ## Outreach Campaign Framework

//       **Week 1: Awareness**
//       * Connect on LinkedIn/appropriate social platform
//       * Engage with their content (comment thoughtfully)
//       * Share relevant industry content (not promotional)

//       **Week 2: Education**
//       * Direct outreach with personalized value proposition
//       * Offer relevant resource (case study, template, assessment)
//       * Request brief conversation about their specific challenges

//       **Week 3: Conversion**
//       * Personalized demo focused on their specific pain points
//       * Limited-time implementation offer
//       * Testimonial sharing from similar business
//     `,
//     "revenue-roadmap": `
//       # 60-Day Revenue Roadmap

//       ## Overview

//       This action plan provides a day-by-day guide to generating your first revenue within 60 days of launch. Based on your business model and market analysis, our data indicates you can achieve first paying customers within 37 days by following this structured approach.

//       ### DAYS 1-15: FOUNDATION BUILDING

//       **Days 1-3: Product Readiness**
//       * Finalize onboarding flow and first-time user experience
//       * Implement analytics tracking for key conversion points
//       * Create 3 demo datasets for different user types
//       * DELIVERABLE: Fully functional product with frictionless setup

//       **Days 4-7: Marketing Infrastructure**
//       * Set up high-conversion landing page with clear value proposition
//       * Create lead magnet: "[Lead magnet relevant to business type]"
//       * Implement email nurture sequence (5 touches)
//       * DELIVERABLE: Complete marketing funnel with tracking

//       **Days 8-10: First Customer Targeting**
//       * Prepare personalized outreach for top 10 prospects
//       * Create custom demo environments for each prospect
//       * Develop ROI calculator specific to each prospect's business
//       * DELIVERABLE: Prospect-specific pitch materials

//       **Days 11-15: Soft Launch**
//       * Invite top 5 prospects to exclusive "founder's beta"
//       * Offer 25% lifetime discount for beta participants
//       * Conduct 1:1 onboarding calls with each participant
//       * DELIVERABLE: First 3-5 active beta users

//       ### DAYS 16-30: OPTIMIZATION & EXPANSION

//       **Days 16-20: User Feedback Loop**
//       * Collect initial user experience data and pain points
//       * Implement 3 highest-impact improvements
//       * Create case studies from beta user experiences
//       * DELIVERABLE: Product improvements and social proof

//       **Days 21-25: Referral Engine**
//       * Launch referral program offering 2 months free for referrals
//       * Train beta users on referral process
//       * Create shareable assets for beta users
//       * DELIVERABLE: Referral system generating warm leads

//       **Days 26-30: Conversion Push**
//       * Convert best-fit beta users to paying customers
//       * Implement limited-time "founding member" pricing
//       * Conduct ROI review calls with each beta user
//       * DELIVERABLE: First 1-2 paying customers

//       ### DAYS 31-45: SCALING ACQUISITION

//       **Days 31-35: Content Acceleration**
//       * Publish success metrics from beta users
//       * Create industry-specific use case content
//       * Launch targeted paid acquisition for best-performing segments
//       * DELIVERABLE: Growing pipeline of qualified leads

//       **Days 36-40: Sales Process Refinement**
//       * Optimize demo-to-signup conversion flow
//       * Implement objection handling frameworks
//       * Create competitive comparison materials
//       * DELIVERABLE: Standardized sales process with 25%+ conversion

//       **Days 41-45: First Revenue Milestone**
//       * Reach 5+ paying customers
//       * Implement automated onboarding for scaling
//       * Launch customer success protocols
//       * DELIVERABLE: Predictable revenue generation system
//     `,
//     "funding-probability": `
//       # Funding Probability Score

//       ## Overview

//       Your business concept has been analyzed against data from 10,000+ similar startups at comparable stages to calculate the probability of securing funding. The analysis considers business model, market timing, competitive landscape, and team composition.

//       **Funding Probability Score: 73%**

//       This places your concept in the **top 25% of analyzed startups** for funding potential. For comparison, the average funding probability for ${
//         businessType || "similar"
//       } startups is 62%.

//       ## Score Breakdown

//       | Factor | Your Score | Category Average | Impact |
//       |--------|------------|------------------|--------|
//       | Market Opportunity | 82/100 | 70/100 | +12% |
//       | Product Innovation | 77/100 | 65/100 | +12% |
//       | Business Model | 75/100 | 68/100 | +7% |
//       | Competitive Position | 71/100 | 59/100 | +12% |
//       | Team Composition | 60/100 | 65/100 | -5% |
//       | Traction Potential | 68/100 | 60/100 | +8% |

//       ## Key Strengths

//       1. **Market Timing (Strong Positive)**

//          Your focus on [key technology/approach] aligns with two major market trends:
//          * [Market trend 1]
//          * [Market trend 2]

//          Investor interest in this space has increased 43% in the past 12 months.

//       2. **Product Differentiation (Strong Positive)**

//          Your [key approach] to a traditional problem creates a clear differentiation from existing solutions. 79% of funded startups in related spaces had similar levels of technical differentiation.

//       ## Areas for Improvement

//       1. **Team Composition (Primary Concern)**

//          Analysis of successfully funded startups shows 82% had at least one founder with direct industry experience in this market. Consider adding an advisor or team member with this background.

//       2. **Go-to-Market Strategy (Secondary Concern)**

//          Your customer acquisition strategy relies heavily on [primary channel], which has scalability limitations. Funded competitors typically had more diversified acquisition channels.

//       ## Optimal Funding Path

//       Based on your score profile, your optimal funding path is:

//       1. **Seed Round: $300K-$500K**
//          * Best potential sources: [Investor type 1], [Investor type 2]
//          * Target timeline: 3-4 months of active fundraising
//          * Suggested valuation range: $2.5M-$3.5M

//       2. **Focus Metrics for Funding Success**
//          * Demonstrate 5+ paying customers before approaching investors
//          * Establish clear unit economics with CAC under $2,500
//          * Show monthly revenue growth of 15%+ for 3 consecutive months

//       ## Recommended Improvements to Increase Score

//       1. Add industry expert to advisory board (potential +7 points)
//       2. Develop channel partner strategy (potential +5 points)
//       3. Create data network effects in product roadmap (potential +6 points)
//       4. Secure one reference customer (potential +8 points)

//       Implementing these changes could increase your funding probability to 85%+, placing you in the top 10% of comparable startups.
//     `,
//   };

//   // Get content for active section
//   const getActiveContent = () => {
//     if (!activeSection) return "";

//     // If premium section and on standard plan, show locked message
//     const section = businessPlanSections.find((s) => s.id === activeSection);
//     if (section && section.type === "premium" && selectedPlan === "standard") {
//       return (
//         <div className="text-center py-10">
//           <div className="bg-gray-50 max-w-lg mx-auto rounded-lg p-8">
//             <Lock className="h-12 w-12 text-gray-400 mx-auto mb-4" />
//             <h3 className="text-xl font-bold text-gray-900 mb-2">Premium Content Locked</h3>
//             <p className="text-gray-600 mb-6">This data-driven insight is only available in the Professional plan.</p>
//             <button
//               onClick={() => setSelectedPlan("professional")}
//               className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
//             >
//               Upgrade to Professional Plan
//             </button>
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="prose max-w-none">
//         <div
//           dangerouslySetInnerHTML={{
//             __html: sectionContent[activeSection]
//               ? sectionContent[activeSection]
//                   .replace(/\n/g, "<br />")
//                   .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
//                   .replace(/\*(.*?)\*/g, "<em>$1</em>")
//                   .replace(/##\s(.*?)$/gm, '<h2 class="text-xl font-bold text-gray-900 mt-6 mb-4">$1</h2>')
//                   .replace(/###\s(.*?)$/gm, '<h3 class="text-lg font-bold text-gray-900 mt-5 mb-3">$1</h3>')
//                   .replace(/\| (.*) \|/g, "| $1 |")
//                   .replace(/\[.*?\]/g, (match) => `<span class="text-purple-600">${match}</span>`)
//               : "Content for this section will be generated in the full version.",
//           }}
//         />
//       </div>
//     );
//   };

//   // Render step 1: Initial input
//   const renderStep1 = () => (
//     <div className="max-w-3xl mx-auto">
//       <div className="text-center mb-8">
//         <h2 className="text-3xl font-bold text-gray-900">Create Your Business Plan</h2>
//         <p className="mt-2 text-lg text-gray-600">Describe your business idea and we'll generate a comprehensive plan</p>
//       </div>

//       <form onSubmit={handleSubmit} className="space-y-6">
//         <div>
//           <label htmlFor="business-type" className="block text-sm font-medium text-gray-700 mb-1">
//             Business Type
//           </label>
//           <select
//             id="business-type"
//             className="block w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-purple-500 focus:border-purple-500"
//             value={businessType}
//             onChange={(e) => setBusinessType(e.target.value)}
//           >
//             <option value="">Select your business type</option>
//             {businessTypes.map((type) => (
//               <option key={type.value} value={type.value}>
//                 {type.label}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div>
//           <label htmlFor="business-idea" className="block text-sm font-medium text-gray-700 mb-1">
//             Describe Your Business Idea
//           </label>
//           <div className="bg-white border-2 border-gray-200 rounded-xl shadow-sm overflow-hidden hover:border-purple-400 transition-colors focus-within:border-purple-400 focus-within:ring-1 focus-within:ring-purple-400">
//             <textarea
//               id="business-idea"
//               rows={6}
//               className="block w-full border-0 py-4 px-6 focus:ring-0 text-lg placeholder-gray-400"
//               placeholder="Describe your business idea in detail..."
//               value={businessIdea}
//               onChange={(e) => setBusinessIdea(e.target.value)}
//             />
//             <div className="py-3 px-6 bg-gray-50 flex items-center justify-between">
//               <p className="text-sm text-gray-500">The more detail you provide, the better your plan will be</p>
//               <button
//                 type="submit"
//                 disabled={isGenerating || !businessIdea.trim()}
//                 className={`flex items-center px-6 py-3 rounded-lg font-medium text-base text-white transition-colors ${
//                   isGenerating || !businessIdea.trim() || !businessType
//                     ? "bg-gray-400 cursor-not-allowed"
//                     : "bg-purple-600 hover:bg-purple-700"
//                 }`}
//               >
//                 {isGenerating ? (
//                   <>
//                     <span className="mr-2">Analyzing</span>
//                     <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
//                   </>
//                 ) : (
//                   <>
//                     <span>Analyze Idea</span>
//                     <ArrowRight className="ml-2 h-5 w-5" />
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
//   );

//   // Render step 2: Plan selection
//   const renderStep2 = () => (
//     <div className="max-w-4xl mx-auto">
//       <div className="text-center mb-8">
//         <h2 className="text-3xl font-bold text-gray-900">Choose Your Business Plan</h2>
//         <p className="mt-2 text-lg text-gray-600">Select the plan that best fits your needs</p>
//       </div>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
//         {/* Standard Plan */}
//         <div
//           className={`border-2 rounded-xl overflow-hidden ${
//             selectedPlan === "standard" ? "border-blue-500 bg-blue-50" : "border-gray-200"
//           }`}
//         >
//           <div className="p-6">
//             <h3 className="text-2xl font-bold text-gray-900 flex items-center">
//               {planTypes.standard.title}
//               {selectedPlan === "standard" && (
//                 <span className="ml-2 px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">Selected</span>
//               )}
//             </h3>
//             <div className="mt-4 flex items-baseline">
//               <span className="text-3xl font-bold text-gray-900">{planTypes.standard.price}</span>
//               <span className="ml-1 text-base text-gray-500">/month</span>
//             </div>
//             <p className="mt-4 text-gray-600">{planTypes.standard.description}</p>
//             <ul className="mt-6 space-y-3">
//               {planTypes.standard.features.map((feature, index) => (
//                 <li key={index} className="flex">
//                   <Check className="h-5 w-5 text-green-500 flex-shrink-0" />
//                   <span className="ml-2 text-gray-600">{feature}</span>
//                 </li>
//               ))}
//             </ul>
//             <button
//               onClick={() => setSelectedPlan("standard")}
//               className={`mt-8 w-full py-3 px-4 rounded-lg text-center font-medium ${
//                 selectedPlan === "standard"
//                   ? "bg-blue-100 text-blue-700 cursor-default"
//                   : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
//               }`}
//             >
//               {selectedPlan === "standard" ? "Selected" : "Select Standard Plan"}
//             </button>
//           </div>
//         </div>

//         {/* Professional Plan */}
//         <div
//           className={`border-2 rounded-xl overflow-hidden ${
//             selectedPlan === "professional" ? "border-purple-500 bg-purple-50" : "border-gray-200"
//           }`}
//         >
//           <div className="absolute right-0 top-0 transform translate-x-2 -translate-y-2">
//             <div className="bg-purple-600 text-white text-xs px-3 py-1 rounded-full font-semibold">Recommended</div>
//           </div>
//           <div className="p-6">
//             <h3 className="text-2xl font-bold text-gray-900 flex items-center">
//               {planTypes.professional.title}
//               {selectedPlan === "professional" && (
//                 <span className="ml-2 px-2 py-1 text-xs font-semibold rounded-full bg-purple-100 text-purple-800">Selected</span>
//               )}
//             </h3>
//             <div className="mt-4 flex items-baseline">
//               <span className="text-3xl font-bold text-gray-900">{planTypes.professional.price}</span>
//               <span className="ml-1 text-base text-gray-500">/month</span>
//             </div>
//             <p className="mt-4 text-gray-600">{planTypes.professional.description}</p>
//             <ul className="mt-6 space-y-3">
//               {planTypes.professional.features.map((feature, index) => (
//                 <li key={index} className="flex">
//                   <Check className="h-5 w-5 text-green-500 flex-shrink-0" />
//                   <span className="ml-2 text-gray-600">{feature}</span>
//                 </li>
//               ))}
//             </ul>
//             <button
//               onClick={() => setSelectedPlan("professional")}
//               className={`mt-8 w-full py-3 px-4 rounded-lg text-center font-medium ${
//                 selectedPlan === "professional"
//                   ? "bg-purple-100 text-purple-700 cursor-default"
//                   : "bg-purple-600 text-white hover:bg-purple-700"
//               }`}
//             >
//               {selectedPlan === "professional" ? "Selected" : "Select Professional Plan"}
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="flex justify-between mt-8">
//         <button onClick={() => setCurrentStep(1)} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">
//           Back
//         </button>
//         <button
//           onClick={handleGeneratePlan}
//           disabled={isGenerating}
//           className={`flex items-center px-6 py-3 rounded-lg font-medium text-base text-white transition-colors ${
//             isGenerating ? "bg-gray-400 cursor-not-allowed" : "bg-purple-600 hover:bg-purple-700"
//           }`}
//         >
//           {isGenerating ? (
//             <>
//               <span className="mr-2">Generating</span>
//               <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
//             </>
//           ) : (
//             <>
//               <span>Generate Business Plan</span>
//               <ChevronRight className="ml-2 h-5 w-5" />
//             </>
//           )}
//         </button>
//       </div>
//     </div>
//   );

//   // Render step 3: The business plan
//   const renderStep3 = () => (
//     <div className="max-w-6xl mx-auto">
//       <div className="flex items-center justify-between mb-6">
//         <h2 className="text-2xl font-bold text-gray-900">{businessIdea}</h2>
//         <div className="flex space-x-3">
//           <div
//             className={`flex items-center px-3 py-1.5 rounded-full text-sm font-medium ${
//               selectedPlan === "professional" ? "bg-purple-100 text-purple-800" : "bg-blue-100 text-blue-800"
//             }`}
//           >
//             {selectedPlan === "professional" ? "Professional Plan" : "Standard Plan"}
//           </div>
//           <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
//             <Download className="h-4 w-4 mr-1" />
//             Export Plan
//           </button>
//         </div>
//       </div>

//       {/* Tab Selector */}
//       <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6">
//         <div className="border-b border-gray-200">
//           <div className="flex">
//             <button
//               className={`flex-1 px-6 py-4 text-center ${
//                 selectedPlan === "standard" ? "bg-blue-50 border-b-2 border-blue-500" : "hover:bg-gray-50"
//               }`}
//               onClick={() => setSelectedPlan("standard")}
//             >
//               <div className="font-medium text-gray-900">Standard Plan</div>
//               <div className="text-sm text-gray-500">100+ page comprehensive business plan</div>
//             </button>

//             <button
//               className={`flex-1 px-6 py-4 text-center ${
//                 selectedPlan === "professional" ? "bg-purple-50 border-b-2 border-purple-500" : "hover:bg-gray-50"
//               }`}
//               onClick={() => setSelectedPlan("professional")}
//             >
//               <div className="font-medium text-gray-900">Professional Plan</div>
//               <div className="text-sm text-gray-500">With 5 premium data-driven insights</div>
//             </button>
//           </div>
//         </div>

//         <div className="p-6">
//           <div className="flex justify-between items-center mb-4">
//             <h3 className="text-lg font-bold text-gray-900">
//               {selectedPlan === "standard" ? "Standard Business Plan" : "Professional Business Plan"}
//             </h3>
//             <button
//               onClick={() => setShowSections(!showSections)}
//               className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700"
//             >
//               {showSections ? (
//                 <>
//                   <EyeOff className="h-4 w-4 mr-1" />
//                   Hide Sections
//                 </>
//               ) : (
//                 <>
//                   <Eye className="h-4 w-4 mr-1" />
//                   Show Sections
//                 </>
//               )}
//             </button>
//           </div>

//           <div className="lg:flex">
//             {showSections && (
//               <div className="w-full lg:w-64 mb-4 lg:mb-0 lg:mr-6 border border-gray-200 rounded-lg overflow-hidden">
//                 <div className="bg-gray-50 px-4 py-2 font-medium text-sm text-gray-700">Document Sections</div>
//                 <div className="divide-y divide-gray-200 max-h-96 overflow-y-auto">
//                   {Object.entries(groupedSections).map(([category, sections]) => (
//                     <div key={category}>
//                       <div className="px-4 py-2 font-medium text-xs text-gray-500 bg-gray-50">{category}</div>
//                       <div>
//                         {sections.map((section) => (
//                           <button
//                             key={section.id}
//                             onClick={() => setActiveSection(section.id)}
//                             className={`w-full px-4 py-2 text-left text-sm flex items-center justify-between ${
//                               activeSection === section.id ? "bg-gray-100" : "hover:bg-gray-50"
//                             }`}
//                           >
//                             <div className="flex items-center">
//                               {section.icon && (
//                                 <span
//                                   className={`mr-2 ${
//                                     selectedPlan === "professional" || section.type !== "premium" ? "text-purple-600" : "text-gray-400"
//                                   }`}
//                                 >
//                                   {section.icon}
//                                 </span>
//                               )}
//                               <span className={`${activeSection === section.id ? "font-medium" : ""}`}>{section.title}</span>
//                             </div>
//                             {section.type === "premium" && selectedPlan === "standard" && <Lock className="h-3 w-3 text-gray-400" />}
//                           </button>
//                         ))}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//                 <div className="p-4 bg-gray-50 border-t border-gray-200">
//                   <div className="text-sm text-gray-500 mb-2">
//                     {selectedPlan === "professional" ? "You have access to all premium sections" : "5 premium sections locked"}
//                   </div>
//                   {selectedPlan === "standard" && (
//                     <button
//                       onClick={() => setSelectedPlan("professional")}
//                       className="w-full py-2 px-3 bg-purple-600 hover:bg-purple-700 text-white text-sm font-medium rounded-md"
//                     >
//                       Upgrade to Professional
//                     </button>
//                   )}
//                 </div>
//               </div>
//             )}

//             <div className="flex-1 border border-gray-200 rounded-lg p-6 overflow-auto">
//               {activeSection ? getActiveContent() : <div className="text-center py-10 text-gray-500">Select a section to view content</div>}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   // Render the appropriate step
//   const renderStep = () => {
//     switch (currentStep) {
//       case 1:
//         return renderStep1();
//       case 2:
//         return renderStep2();
//       case 3:
//         return renderStep3();
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <header className="bg-white shadow-sm">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center py-6">
//             <div className="flex items-center">
//               <Zap className="h-8 w-8 text-purple-600" />
//               <h1 className="ml-2 text-2xl font-bold text-gray-900">LaunchPad AI</h1>
//             </div>

//             <div>
//               <button className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-purple-600 hover:bg-purple-700">
//                 Sign Up
//               </button>
//             </div>
//           </div>
//         </div>
//       </header>

//       <main className="py-8">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           {/* Steps indicator */}
//           <div className="max-w-3xl mx-auto mb-8">
//             <div className="flex items-center justify-center">
//               <div className={`flex items-center ${currentStep > 1 ? "text-purple-600" : "text-gray-600"}`}>
//                 <div
//                   className={`flex items-center justify-center w-8 h-8 rounded-full ${
//                     currentStep >= 1 ? "bg-purple-600 text-white" : "bg-gray-200 text-gray-600"
//                   }`}
//                 >
//                   1
//                 </div>
//                 <span className="ml-2 text-sm font-medium hidden sm:block">Describe Idea</span>
//               </div>
//               <div className={`w-12 sm:w-24 h-1 mx-2 ${currentStep > 1 ? "bg-purple-600" : "bg-gray-200"}`}></div>
//               <div className={`flex items-center ${currentStep > 2 ? "text-purple-600" : "text-gray-600"}`}>
//                 <div
//                   className={`flex items-center justify-center w-8 h-8 rounded-full ${
//                     currentStep >= 2 ? "bg-purple-600 text-white" : "bg-gray-200 text-gray-600"
//                   }`}
//                 >
//                   2
//                 </div>
//                 <span className="ml-2 text-sm font-medium hidden sm:block">Choose Plan</span>
//               </div>
//               <div className={`w-12 sm:w-24 h-1 mx-2 ${currentStep > 2 ? "bg-purple-600" : "bg-gray-200"}`}></div>
//               <div className={`flex items-center ${currentStep > 3 ? "text-purple-600" : "text-gray-600"}`}>
//                 <div
//                   className={`flex items-center justify-center w-8 h-8 rounded-full ${
//                     currentStep >= 3 ? "bg-purple-600 text-white" : "bg-gray-200 text-gray-600"
//                   }`}
//                 >
//                   3
//                 </div>
//                 <span className="ml-2 text-sm font-medium hidden sm:block">View Business Plan</span>
//               </div>
//             </div>
//           </div>

//           {renderStep()}
//         </div>
//       </main>
//     </div>
//   );
// };

// export default BusinessPlannerFinalStrategy;

import React, { useState } from "react";
import {
  Zap,
  ChevronRight,
  ChevronDown,
  Check,
  Lock,
  Star,
  FileText,
  Sparkles,
  Download,
  Globe,
  ArrowRight,
  Edit,
  Eye,
  EyeOff,
} from "lucide-react";

const BusinessPlannerCorrectFlow = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [businessIdea, setBusinessIdea] = useState("");
  const [language, setLanguage] = useState("english");
  const [isGenerating, setIsGenerating] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("standard");
  const [activeSection, setActiveSection] = useState("executive-summary");
  const [showSections, setShowSections] = useState(true);

  // Sample languages for dropdown
  const languages = [
    { value: "english", label: "English" },
    { value: "spanish", label: "Spanish" },
    { value: "french", label: "French" },
    { value: "german", label: "German" },
    { value: "chinese", label: "Chinese" },
    { value: "japanese", label: "Japanese" },
    { value: "russian", label: "Russian" },
    { value: "portuguese", label: "Portuguese" },
    { value: "arabic", label: "Arabic" },
    { value: "hindi", label: "Hindi" },
    { value: "italian", label: "Italian" },
    { value: "dutch", label: "Dutch" },
    { value: "swedish", label: "Swedish" },
    { value: "korean", label: "Korean" },
  ];

  // Define plan types
  const planTypes = {
    standard: {
      title: "Standard Plan",
      price: "$39",
      description: "100+ page business plan with standard sections",
      features: [
        "55 standard business plan sections",
        "Executive Summary",
        "Comprehensive financial projections",
        "Static section titles",
        "Same structure for all businesses",
      ],
      icon: <FileText className="h-5 w-5 text-blue-500" />,
    },
    professional: {
      title: "Professional Plan",
      price: "$59",
      description: "100+ page business plan with dynamically generated sections",
      features: [
        "55 dynamically generated sections",
        "Custom-tailored to your specific business",
        "Industry-specific terminology",
        "Unique section titles for your business",
        "AI-optimized report structure",
      ],
      icon: <Sparkles className="h-5 w-5 text-purple-600" />,
    },
  };

  // Static section titles (Standard Plan)
  const staticSections = [
    {
      category: "Business Foundation",
      sections: [
        { id: "executive-summary", title: "Executive Summary", recommended: true },
        { id: "business-overview", title: "Business Overview", recommended: true },
        { id: "vision-mission", title: "Vision and Mission Statement", recommended: true },
        { id: "business-objectives", title: "Business Objectives", recommended: true },
        { id: "legal-structure", title: "Legal Structure", recommended: true },
      ],
    },
    {
      category: "Market Analysis",
      sections: [
        { id: "industry-analysis", title: "Industry Analysis", recommended: true },
        { id: "market-segmentation", title: "Market Segmentation", recommended: true },
        { id: "target-market", title: "Target Market", recommended: true },
        { id: "market-needs", title: "Market Needs", recommended: true },
        { id: "market-trends", title: "Market Trends", recommended: true },
      ],
    },
    {
      category: "Competitive Analysis",
      sections: [
        { id: "competitive-landscape", title: "Competitive Landscape", recommended: true },
        { id: "direct-competitors", title: "Direct Competitors", recommended: true },
        { id: "indirect-competitors", title: "Indirect Competitors", recommended: true },
        { id: "competitive-advantage", title: "Competitive Advantage", recommended: true },
        { id: "barriers-to-entry", title: "Barriers to Entry", recommended: true },
      ],
    },
    {
      category: "Products and Services",
      sections: [
        { id: "product-description", title: "Product/Service Description", recommended: true },
        { id: "value-proposition", title: "Value Proposition", recommended: true },
        { id: "product-development", title: "Product Development", recommended: true },
        { id: "intellectual-property", title: "Intellectual Property", recommended: true },
        { id: "future-products", title: "Future Products/Services", recommended: true },
      ],
    },
    {
      category: "Marketing Strategy",
      sections: [
        { id: "marketing-overview", title: "Marketing Strategy Overview", recommended: true },
        { id: "pricing-strategy", title: "Pricing Strategy", recommended: true },
        { id: "promotion-strategy", title: "Promotion Strategy", recommended: true },
        { id: "distribution-channels", title: "Distribution Channels", recommended: true },
        { id: "sales-strategy", title: "Sales Strategy", recommended: true },
      ],
    },
  ];

  // Dynamic section titles (Professional Plan) - would be generated by ChatGPT API
  // This is just a sample of what dynamic titles might look like for a specific business
  const dynamicSections = [
    {
      category: "Foundation & Vision",
      sections: [
        { id: "executive-summary", title: "Executive Summary: AI-Powered Inventory Management", recommended: true },
        { id: "business-overview", title: "Retail Tech Innovation Blueprint", recommended: true },
        { id: "problem-solution", title: "Solving the Small Retailer Inventory Challenge", recommended: true },
        { id: "market-opportunity", title: "The $4.7B Retail Inventory Management Opportunity", recommended: true },
        { id: "core-value-proposition", title: "Why Retailers Will Choose Your AI Solution", recommended: true },
      ],
    },
    {
      category: "Market Intelligence",
      sections: [
        { id: "retail-industry-analysis", title: "Retail Industry Technology Adoption Patterns", recommended: true },
        { id: "small-retailer-pain-points", title: "Small Retailer Inventory Pain Points", recommended: true },
        { id: "post-pandemic-retail-shifts", title: "Post-Pandemic Retail Technology Shifts", recommended: true },
        { id: "inventory-software-landscape", title: "Inventory Software Competitive Landscape", recommended: true },
        { id: "target-retailer-profile", title: "Ideal Small Retailer Customer Profile", recommended: true },
      ],
    },
    {
      category: "Technology Strategy",
      sections: [
        { id: "ai-algorithm-advantage", title: "AI Algorithm Competitive Advantage", recommended: true },
        { id: "predictive-analytics-engine", title: "Predictive Analytics Engine Architecture", recommended: true },
        { id: "pos-integration-strategy", title: "POS System Integration Strategy", recommended: true },
        { id: "data-security-model", title: "Retail Data Security Model", recommended: true },
        { id: "mobile-first-design", title: "Mobile-First Retail Floor Experience", recommended: true },
      ],
    },
    {
      category: "Go-to-Market Strategy",
      sections: [
        { id: "retail-acquisition-funnel", title: "Retail Customer Acquisition Funnel", recommended: true },
        { id: "tier-based-pricing", title: "Tier-Based Pricing for Different Store Sizes", recommended: true },
        { id: "retail-marketing-channels", title: "Retail-Specific Marketing Channels", recommended: true },
        { id: "implementation-timeline", title: "Same-Day Implementation Advantage", recommended: true },
        { id: "first-customer-acquisition", title: "First 10 Retail Customer Acquisition Plan", recommended: true },
      ],
    },
    {
      category: "Financial Projections",
      sections: [
        { id: "retailtech-revenue-model", title: "RetailTech SaaS Revenue Model", recommended: true },
        { id: "customer-acquisition-costs", title: "Small Retailer Acquisition Costs", recommended: true },
        { id: "inventory-optimization-roi", title: "Inventory Optimization ROI Calculation", recommended: true },
        { id: "funding-requirements", title: "Funding Requirements for Retail AI Solution", recommended: true },
        { id: "break-even-analysis", title: "Break-Even Analysis for Inventory SaaS", recommended: true },
      ],
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (businessIdea.trim() && language) {
      setIsGenerating(true);
      setTimeout(() => {
        setIsGenerating(false);
        setCurrentStep(2);
      }, 2000);
    }
  };

  const handleGeneratePlan = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setCurrentStep(3);
      setActiveSection("executive-summary");
    }, 3000);
  };

  // Get the appropriate sections based on selected plan
  const getSections = () => {
    return selectedPlan === "standard" ? staticSections : dynamicSections;
  };

  // Flatten all sections for easier lookup
  const getAllSections = () => {
    const sections = [];
    getSections().forEach((category) => {
      category.sections.forEach((section) => {
        sections.push({
          ...section,
          category: category.category,
        });
      });
    });
    return sections;
  };

  // Sample content for Executive Summary
  const getExecutiveSummaryContent = () => {
    return selectedPlan === "standard"
      ? `
        # Executive Summary
        
        ## Business Overview
        
        ${
          businessIdea || "This business will..."
        } represents a significant opportunity in the market. The solution addresses key pain points experienced by customers in this space while providing a competitive advantage through its unique approach.
        
        ## Target Market
        
        The primary target market consists of [target customer profile] who currently struggle with [key problem]. This represents approximately [market size] in [target geography], with an estimated [percentage]% experiencing related challenges.
        
        ## Competitive Advantage
        
        Unlike existing solutions in the market, this business:
        
        1. [Key differentiator 1]
        2. [Key differentiator 2]
        3. [Key differentiator 3]
        4. [Key differentiator 4]
        
        ## Financial Projection Highlights
        
        * First revenue expected within [X] days of launch
        * Projected first-year revenue: $[amount]
        * Estimated break-even point: Month [X]
        * [X]% probability of securing seed funding based on market dynamics
        
        ## Funding Request
        
        $[amount] in seed funding is sought to complete development, launch marketing initiatives, and support operations for the first 12 months until the business achieves sustainable revenue growth.
      `
      : `
        # Executive Summary: AI-Powered Inventory Management
        
        ## Retail Technology Innovation
        
        ${
          businessIdea || "This AI-powered inventory management platform for small retailers"
        } addresses a critical pain point in the $4.7B retail inventory management market. By leveraging artificial intelligence to predict optimal stock levels, this solution helps independent retailers reduce costs, eliminate stockouts, and improve cash flow without requiring technical expertise.
        
        ## Target Retail Market
        
        The primary target consists of independent retailers with 1-5 locations and $500K-$5M in annual revenue who currently use spreadsheets or basic POS systems for inventory. This represents approximately 340,000 businesses in the US alone, with an estimated 73% experiencing inventory optimization challenges.
        
        ## Retail Technology Competitive Advantage
        
        Unlike existing inventory solutions that focus solely on tracking, this platform:
        
        1. Uses AI to automatically predict optimal stock levels based on historical data
        2. Provides same-day implementation with minimal setup requirements
        3. Offers mobile-first design optimized for in-store use
        4. Scales pricing based on store size, not SKU count (unlike competitors)
        
        ## Retail SaaS Financial Highlights
        
        * First revenue expected within 37 days of launch
        * Projected first-year revenue: $180,513
        * Estimated break-even point: Month 14
        * 73% probability of securing seed funding based on RetailTech funding trends
        
        ## Funding Requirements
        
        $350,000 in seed funding is sought to complete development, launch market-specific integrations with retail POS systems, and support operations until the business achieves sustainable revenue in Month 14.
      `;
  };

  // Get content for active section
  const getSectionContent = () => {
    if (activeSection === "executive-summary") {
      return getExecutiveSummaryContent();
    }

    // For other sections, would generate content dynamically
    // This is a placeholder for demo purposes
    const section = getAllSections().find((s) => s.id === activeSection);
    if (!section) return "";

    return `
      # ${section.title}
      
      Content for ${section.title} would be dynamically generated based on your business idea:
      
      "${businessIdea}"
      
      ${
        selectedPlan === "standard"
          ? "This is using the standard plan with fixed section titles."
          : "This is using the professional plan with dynamically generated section titles specific to your business type."
      }
      
      Each section would contain several pages of detailed, industry-specific content tailored to your business needs.
    `;
  };

  // Render step 1: Initial input
  const renderStep1 = () => (
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-gray-900">Create Your Business Plan</h2>
        <p className="mt-2 text-lg text-gray-600">Describe your business idea and we'll generate a comprehensive plan</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="language" className="block text-sm font-medium text-gray-700 mb-1">
            Select Language
          </label>
          <select
            id="language"
            className="block w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-purple-500 focus:border-purple-500"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
          >
            {languages.map((lang) => (
              <option key={lang.value} value={lang.value}>
                {lang.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="business-idea" className="block text-sm font-medium text-gray-700 mb-1">
            Describe Your Business Idea
          </label>
          <div className="bg-white border-2 border-gray-200 rounded-xl shadow-sm overflow-hidden hover:border-purple-400 transition-colors focus-within:border-purple-400 focus-within:ring-1 focus-within:ring-purple-400">
            <textarea
              id="business-idea"
              rows={6}
              className="block w-full border-0 py-4 px-6 focus:ring-0 text-lg placeholder-gray-400"
              placeholder="Describe your business idea in detail..."
              value={businessIdea}
              onChange={(e) => setBusinessIdea(e.target.value)}
            />
            <div className="py-3 px-6 bg-gray-50 flex items-center justify-between">
              <p className="text-sm text-gray-500">The more detail you provide, the better your plan will be</p>
              <button
                type="submit"
                disabled={isGenerating || !businessIdea.trim()}
                className={`flex items-center px-6 py-3 rounded-lg font-medium text-base text-white transition-colors ${
                  isGenerating || !businessIdea.trim() ? "bg-gray-400 cursor-not-allowed" : "bg-purple-600 hover:bg-purple-700"
                }`}
              >
                {isGenerating ? (
                  <>
                    <span className="mr-2">Analyzing</span>
                    <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
                  </>
                ) : (
                  <>
                    <span>Analyze Idea</span>
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );

  // Render step 2: Plan selection
  const renderStep2 = () => (
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-gray-900">Choose Your Report Type</h2>
        <p className="mt-2 text-lg text-gray-600">Select the business plan format that best fits your needs</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
        {/* Standard Plan */}
        <div
          className={`border-2 rounded-xl overflow-hidden ${
            selectedPlan === "standard" ? "border-blue-500 bg-blue-50" : "border-gray-200"
          }`}
        >
          <div className="p-6">
            <div className="flex items-center mb-4">
              <div className="p-2 bg-blue-100 rounded-lg">
                <FileText className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="ml-3 text-2xl font-bold text-gray-900">{planTypes.standard.title}</h3>
            </div>

            <div className="mt-4 flex items-baseline">
              <span className="text-3xl font-bold text-gray-900">{planTypes.standard.price}</span>
              <span className="ml-1 text-base text-gray-500">/month</span>
            </div>
            <p className="mt-4 text-gray-600">{planTypes.standard.description}</p>
            <ul className="mt-6 space-y-3">
              {planTypes.standard.features.map((feature, index) => (
                <li key={index} className="flex">
                  <Check className="h-5 w-5 text-green-500 flex-shrink-0" />
                  <span className="ml-2 text-gray-600">{feature}</span>
                </li>
              ))}
            </ul>
            <button
              onClick={() => setSelectedPlan("standard")}
              className={`mt-8 w-full py-3 px-4 rounded-lg text-center font-medium ${
                selectedPlan === "standard"
                  ? "bg-blue-100 text-blue-700 cursor-default"
                  : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
              }`}
            >
              {selectedPlan === "standard" ? "Selected" : "Select Standard Plan"}
            </button>
          </div>
        </div>

        {/* Professional Plan */}
        <div
          className={`border-2 rounded-xl overflow-hidden ${
            selectedPlan === "professional" ? "border-purple-500 bg-purple-50" : "border-gray-200"
          }`}
        >
          <div className="absolute right-0 top-0 transform translate-x-2 -translate-y-2">
            <div className="bg-purple-600 text-white text-xs px-3 py-1 rounded-full font-semibold">Recommended</div>
          </div>
          <div className="p-6">
            <div className="flex items-center mb-4">
              <div className="p-2 bg-purple-100 rounded-lg">
                <Sparkles className="h-6 w-6 text-purple-600" />
              </div>
              <h3 className="ml-3 text-2xl font-bold text-gray-900">{planTypes.professional.title}</h3>
            </div>
            <div className="mt-4 flex items-baseline">
              <span className="text-3xl font-bold text-gray-900">{planTypes.professional.price}</span>
              <span className="ml-1 text-base text-gray-500">/month</span>
            </div>
            <p className="mt-4 text-gray-600">{planTypes.professional.description}</p>
            <ul className="mt-6 space-y-3">
              {planTypes.professional.features.map((feature, index) => (
                <li key={index} className="flex">
                  <Check className="h-5 w-5 text-green-500 flex-shrink-0" />
                  <span className="ml-2 text-gray-600">{feature}</span>
                </li>
              ))}
            </ul>
            <button
              onClick={() => setSelectedPlan("professional")}
              className={`mt-8 w-full py-3 px-4 rounded-lg text-center font-medium ${
                selectedPlan === "professional"
                  ? "bg-purple-100 text-purple-700 cursor-default"
                  : "bg-purple-600 text-white hover:bg-purple-700"
              }`}
            >
              {selectedPlan === "professional" ? "Selected" : "Select Professional Plan"}
            </button>
          </div>
        </div>
      </div>

      <div className="flex justify-between mt-8">
        <button onClick={() => setCurrentStep(1)} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">
          Back
        </button>
        <button
          onClick={handleGeneratePlan}
          disabled={isGenerating}
          className={`flex items-center px-6 py-3 rounded-lg font-medium text-base text-white transition-colors ${
            isGenerating ? "bg-gray-400 cursor-not-allowed" : "bg-purple-600 hover:bg-purple-700"
          }`}
        >
          {isGenerating ? (
            <>
              <span className="mr-2">Generating</span>
              <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
            </>
          ) : (
            <>
              <span>Generate Business Plan</span>
              <ChevronRight className="ml-2 h-5 w-5" />
            </>
          )}
        </button>
      </div>

      <div className="mt-8 border-t border-gray-200 pt-6">
        <div className="text-center">
          <h3 className="text-lg font-bold text-gray-900 mb-2">Standard vs Professional Comparison</h3>
          <p className="text-gray-600 mb-4">See the difference in section titles and content quality</p>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 font-medium text-gray-700">Sample Section Titles Comparison</div>
          <div className="divide-y divide-gray-200">
            <div className="grid grid-cols-2 divide-x divide-gray-200">
              <div className="p-4">
                <div className="font-medium text-blue-600 mb-2 flex items-center">
                  <FileText className="h-4 w-4 mr-1" />
                  Standard Plan Sections
                </div>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li>Marketing Strategy</li>
                  <li>Competitive Analysis</li>
                  <li>Product Description</li>
                  <li>Target Market</li>
                  <li>Financial Projections</li>
                </ul>
              </div>
              <div className="p-4">
                <div className="font-medium text-purple-600 mb-2 flex items-center">
                  <Sparkles className="h-4 w-4 mr-1" />
                  Professional Plan Sections
                </div>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li>Retail-Specific Marketing Channels</li>
                  <li>Inventory Software Competitive Landscape</li>
                  <li>Mobile-First Retail Floor Experience</li>
                  <li>Ideal Small Retailer Customer Profile</li>
                  <li>RetailTech SaaS Revenue Model</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Render step 3: The business plan
  const renderStep3 = () => (
    <div className="max-w-6xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900">
          {businessIdea.length > 50 ? `${businessIdea.substring(0, 50)}...` : businessIdea}
        </h2>
        <div className="flex space-x-3">
          <div
            className={`flex items-center px-3 py-1.5 rounded-full text-sm font-medium ${
              selectedPlan === "professional" ? "bg-purple-100 text-purple-800" : "bg-blue-100 text-blue-800"
            }`}
          >
            {selectedPlan === "professional" ? "Professional Plan" : "Standard Plan"}
          </div>
          <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
            <Download className="h-4 w-4 mr-1" />
            Export Plan
          </button>
        </div>
      </div>

      {/* Tab Selector */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6">
        <div className="border-b border-gray-200">
          <div className="flex">
            <button
              className={`flex-1 px-6 py-4 text-center ${
                selectedPlan === "standard" ? "bg-blue-50 border-b-2 border-blue-500" : "hover:bg-gray-50"
              }`}
              onClick={() => setSelectedPlan("standard")}
            >
              <div className="flex items-center justify-center">
                <FileText className="h-5 w-5 mr-2 text-blue-500" />
                <div className="font-medium text-gray-900">Standard Plan</div>
              </div>
              <div className="text-sm text-gray-500">Fixed 55-section business plan</div>
            </button>

            <button
              className={`flex-1 px-6 py-4 text-center ${
                selectedPlan === "professional" ? "bg-purple-50 border-b-2 border-purple-500" : "hover:bg-gray-50"
              }`}
              onClick={() => setSelectedPlan("professional")}
            >
              <div className="flex items-center justify-center">
                <Sparkles className="h-5 w-5 mr-2 text-purple-600" />
                <div className="font-medium text-gray-900">Professional Plan</div>
              </div>
              <div className="text-sm text-gray-500">Dynamic 55-section business plan</div>
            </button>
          </div>
        </div>

        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-bold text-gray-900">
              {selectedPlan === "standard" ? "Standard Business Plan" : "Dynamic Business Plan"}
            </h3>
            <button
              onClick={() => setShowSections(!showSections)}
              className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700"
            >
              {showSections ? (
                <>
                  <EyeOff className="h-4 w-4 mr-1" />
                  Hide Sections
                </>
              ) : (
                <>
                  <Eye className="h-4 w-4 mr-1" />
                  Show Sections
                </>
              )}
            </button>
          </div>

          <div className="lg:flex">
            {showSections && (
              <div className="w-full lg:w-64 mb-4 lg:mb-0 lg:mr-6 border border-gray-200 rounded-lg overflow-hidden">
                <div className="bg-gray-50 px-4 py-2 font-medium text-sm text-gray-700 flex justify-between items-center">
                  <span>Plan Sections</span>
                  <span className="bg-gray-200 text-gray-700 px-2 py-0.5 rounded-full text-xs">55 sections</span>
                </div>
                <div className="divide-y divide-gray-200 max-h-96 overflow-y-auto">
                  {getSections().map((category) => (
                    <div key={category.category}>
                      <div className="px-4 py-2 font-medium text-xs text-gray-500 bg-gray-50">{category.category}</div>
                      <div>
                        {category.sections.map((section) => (
                          <button
                            key={section.id}
                            onClick={() => setActiveSection(section.id)}
                            className={`w-full px-4 py-2 text-left text-sm flex items-center justify-between ${
                              activeSection === section.id ? "bg-gray-100" : "hover:bg-gray-50"
                            }`}
                          >
                            <span className={`${activeSection === section.id ? "font-medium" : ""}`}>{section.title}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="p-4 bg-gray-50 border-t border-gray-200">
                  <div className="text-sm text-gray-600">
                    {selectedPlan === "professional"
                      ? "Dynamically generated section titles based on your business"
                      : "Standard section titles used in all plans"}
                  </div>
                </div>
              </div>
            )}

            <div className="flex-1 border border-gray-200 rounded-lg p-6 overflow-auto min-h-[400px]">
              <div className="prose max-w-none">
                <div
                  dangerouslySetInnerHTML={{
                    __html: getSectionContent()
                      .replace(/\n/g, "<br />")
                      .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
                      .replace(/\*(.*?)\*/g, "<em>$1</em>")
                      .replace(/##\s(.*?)$/gm, '<h2 class="text-xl font-bold text-gray-900 mt-6 mb-4">$1</h2>')
                      .replace(/###\s(.*?)$/gm, '<h3 class="text-lg font-bold text-gray-900 mt-5 mb-3">$1</h3>')
                      .replace(/\[(.*?)\]/g, '<span class="text-purple-600">$1</span>')
                      .replace(/# (.*?)$/gm, '<h1 class="text-2xl font-bold text-gray-900 mb-6">$1</h1>'),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Render the appropriate step
  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return renderStep1();
      case 2:
        return renderStep2();
      case 3:
        return renderStep3();
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center">
              <Zap className="h-8 w-8 text-purple-600" />
              <h1 className="ml-2 text-2xl font-bold text-gray-900">LaunchPad AI</h1>
            </div>

            <div>
              <button className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-purple-600 hover:bg-purple-700">
                Sign Up
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Steps indicator */}
          <div className="max-w-3xl mx-auto mb-8">
            <div className="flex items-center justify-center">
              <div className={`flex items-center ${currentStep > 1 ? "text-purple-600" : "text-gray-600"}`}>
                <div
                  className={`flex items-center justify-center w-8 h-8 rounded-full ${
                    currentStep >= 1 ? "bg-purple-600 text-white" : "bg-gray-200 text-gray-600"
                  }`}
                >
                  1
                </div>
                <span className="ml-2 text-sm font-medium hidden sm:block">Describe Idea</span>
              </div>
              <div className={`w-12 sm:w-24 h-1 mx-2 ${currentStep > 1 ? "bg-purple-600" : "bg-gray-200"}`}></div>
              <div className={`flex items-center ${currentStep > 2 ? "text-purple-600" : "text-gray-600"}`}>
                <div
                  className={`flex items-center justify-center w-8 h-8 rounded-full ${
                    currentStep >= 2 ? "bg-purple-600 text-white" : "bg-gray-200 text-gray-600"
                  }`}
                >
                  2
                </div>
                <span className="ml-2 text-sm font-medium hidden sm:block">Choose Plan</span>
              </div>
              <div className={`w-12 sm:w-24 h-1 mx-2 ${currentStep > 2 ? "bg-purple-600" : "bg-gray-200"}`}></div>
              <div className={`flex items-center ${currentStep > 3 ? "text-purple-600" : "text-gray-600"}`}>
                <div
                  className={`flex items-center justify-center w-8 h-8 rounded-full ${
                    currentStep >= 3 ? "bg-purple-600 text-white" : "bg-gray-200 text-gray-600"
                  }`}
                >
                  3
                </div>
                <span className="ml-2 text-sm font-medium hidden sm:block">View Business Plan</span>
              </div>
            </div>
          </div>

          {renderStep()}
        </div>
      </main>
    </div>
  );
};

export default BusinessPlannerCorrectFlow;
